import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Customer } from "../../master-data/master-data.model";
import { NEW_UI_FORM_FIELD_DEFAULTS } from "../../shared/styles/new-ui-form-field";

@Component({
    selector: "app-chains-customers-edit",
    templateUrl: "./chains-customers-edit.component.html",
    styleUrls: ["./chains-customers-edit.component.scss"],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChainsCustomersEditComponent {
  dialogRef = inject<MatDialogRef<ChainsCustomersEditComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  customer: Customer = null;

  onCustomerSelected($event: Customer) {
    this.customer = $event;
  }

  clearCustomer() {
    this.customer = null;
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.dialogRef.close(this.customer);
  }
}
